var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./IndexSocials.jinja');
require('./IndexSocials.less');

var objectFitImages = require('object-fit-images');
require('assets/owl.carousel.min.css');
require('assets/owl.theme.default.min.css');
require('owl.carousel.min-2.2.1.js');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        this.$('.IndexSocials-latestPhone').owlCarousel({
            items: 2,
            dots: true,
            mouseDrag: false,
            smartSpeed: 300,
            slideBy: 'page'
        });

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexSocials/IndexSocials.js
// module id = 180
// module chunks = 0